export const RECENT_ACTIVITY_COMMENT = 'comment';
export const RECENT_ACTIVITY_REPLY = 'reply';
